(() => {
  const selector = '[data-rmg-faq]';

  const setActiveTopic = (section, activeLink) => {
    section.querySelectorAll('[data-faq-topic]').forEach((link) => {
      const active = link === activeLink;
      link.classList.toggle('is-active', active);
      if (active) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const initialise = (section) => {
    if (!section || section.dataset.faqInitialised === 'true') return;
    section.dataset.faqInitialised = 'true';

    const search = section.querySelector('[data-faq-search]');
    const clear = section.querySelector('[data-faq-clear]');
    const results = section.querySelector('[data-faq-results]');
    const empty = section.querySelector('[data-faq-empty]');
    const items = Array.from(section.querySelectorAll('[data-faq-item]'));
    const groups = Array.from(section.querySelectorAll('[data-faq-group]'));
    const topicLinks = Array.from(section.querySelectorAll('[data-faq-topic]'));

    if (!search || !results || !empty || items.length === 0) return;

    const applySearch = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const searchableText = item.textContent.toLocaleLowerCase();
        const visible = term === '' || searchableText.includes(term);
        item.hidden = !visible;
        if (visible) visibleCount += 1;
        if (!visible) item.removeAttribute('open');
      });

      groups.forEach((group) => {
        const hasVisibleItem = Array.from(group.querySelectorAll('[data-faq-item]')).some((item) => !item.hidden);
        group.hidden = !hasVisibleItem;
      });

      empty.hidden = visibleCount !== 0;
      clear.hidden = term === '';
      results.textContent = term === ''
        ? ''
        : `${visibleCount} ${visibleCount === 1 ? 'answer' : 'answers'} found`;

      if (term !== '') {
        const allQuestionsLink = topicLinks.find((link) => link.dataset.faqTopic === 'all');
        if (allQuestionsLink) setActiveTopic(section, allQuestionsLink);
      }
    };

    search.addEventListener('input', applySearch);

    if (clear) {
      clear.addEventListener('click', () => {
        search.value = '';
        applySearch();
        search.focus();
      });
    }

    topicLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        const target = targetId ? section.querySelector(targetId) : null;

        if (search.value !== '') {
          search.value = '';
          applySearch();
        }

        setActiveTopic(section, link);

        if (target) {
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', targetId);
          }
        }
      });
    });

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });

    applySearch();
  };

  const initialiseAll = (root = document) => {
    if (root.matches && root.matches(selector)) initialise(root);
    root.querySelectorAll(selector).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
